import {
  Driver_Read_Typeahead,
  getV1CompaniesCompanyIdDriversTypeahead,
  GetV1CompaniesCompanyIdDriversTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { DriverTypeahead } from '~hooks/useDrivers/models';

import DriverOptionSecondary from '../Parts/DriverOptionSecondary';
import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Driver_Read_Typeahead,
  DriverTypeahead,
  GetV1CompaniesCompanyIdDriversTypeaheadData
> & { companyId: string; shared?: boolean };

export default function AutocompleteDriversTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  shared,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteDriversTypeahead"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId },
          query: shared === undefined ? {} : { 'filter[shared]': shared },
        },
        request: getV1CompaniesCompanyIdDriversTypeahead,
      }}
      parseFn={(item: Driver_Read_Typeahead) => {
        const parsed = DriverTypeahead.parse(item);

        return { _entity: parsed, label: parsed.fullName, value: parsed.id };
      }}
      renderSecondary={(option, inputValue) => (
        <DriverOptionSecondary
          companyId={companyId}
          driver={option._entity}
          query={inputValue}
        />
      )}
    />
  );
}
